<template>
  <div class="entrance-wrapper">
    <div class="title" v-html="title" />
    <template v-if="detailData.pageIndex === 0">
      <div v-if="detailData.subtitle" class="sub-title">{{ detailData.subtitle }}</div>
      <div v-if="detailData.icon" class="title-icon">
        <img v-if="detailData.icon" :src="detailData.icon">
      </div>
      <div class="btns-wrapper">
        <div v-if="detailData.btnTitle" class="btn1" @click.stop="imhere">{{ detailData.btnTitle }}</div>
        <div class="btn2" @click.stop="close">稍后再填</div>
      </div>
    </template>
    <template v-else>
      <div class="enter-type-wrapper">
        <div v-if="detailData.pageIndex === 1" class="enter-type-item" @click.stop="openPoi">
          <img :src="poi" alt="">
          <div>开启位置信息</div>
        </div>
        <div class="enter-type-item" @click.stop="scancode">
          <img :src="qrCode" alt="">
          <div>扫描标签二维码</div>
        </div>
      </div>
      <div class="btns-wrapper">
        <div class="btn2" @click.stop="close">稍后再填</div>
      </div>
      <div v-if="detailData.orderTimeTips" class="order-time-tips">
        {{ detailData.orderTimeTips }}
      </div>
    </template>
    <div class="entrance-bottom"></div>
  </div>
</template>

<script>
import { jsBridgeStartLocationPromise, jsBridgeScanCodePromise, jsBridgeCheckLocationPromise, jsBridgeCloseDialogPromise } from '@/utils/bridgeRegisterHandle';
import poiImg from '@/assets/crf/poi.png'
import poiImgTeacat from '@/assets/crf/poi-teacat.png'
import qrcodeImg from '@/assets/crf/qrcode.png'
import qrcodeImgTeacat from '@/assets/crf/qrcode-teacat.png'
import { highVersion } from './helper';
import { Toast } from 'vant';

export default {
  name: 'CrfEntrance',
  props: {
    detailData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
  },
  data() {
    return {
      isCotti: navigator.userAgent?.includes('cottiCoffee'),
    }
  },
  computed: {
    title() {
      return this.detailData.title?.replaceAll('\\n', '<br>')
    },
    poi() {
      return this.isCotti ? poiImg : poiImgTeacat
    },
    qrCode() {
      return this.isCotti ? qrcodeImg : qrcodeImgTeacat
    }
  },
  mounted() {
    const $this = this;
    // navtive通知H5-已获取最新位置信息
    window.getNewPoi = (res) => {
      console.log('getNewPoi', res)
      $this.$emit('refresh', res)
    }
  },
  methods: {
    close () {
      jsBridgeCloseDialogPromise();
    },
    async imhere() {
      let hasAuth = 1;
      if (highVersion()) {
        hasAuth = (await jsBridgeCheckLocationPromise())?.status == 1;
      }
      console.log('highVersion', highVersion(), 'hasAuth', hasAuth)
      if (hasAuth && highVersion()) {
        jsBridgeStartLocationPromise().then(res => {
          this.$emit('refresh', {
            ...res,
            triggerType: 1
          })
        })
      } else {
        this.$emit('refresh', {
          triggerType: 1
        })
      }
    },
    openPoi() {
      if (highVersion()) {
        jsBridgeStartLocationPromise().then(res => {
          this.$emit('refresh', res)
        })
      } else {
        Toast('请先升级App后再试')
      }
    },
    scancode() {
      if (highVersion()) {
        jsBridgeScanCodePromise().then(res => {
          this.$emit('refresh', {
            scancode: res
          })
        })
      } else {
        Toast('请先升级App后再试')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.entrance-wrapper {
  position: absolute;
  bottom: 0;
  width: 100%;
  font-family: PingFangSC, PingFang SC;
  padding: 40px 32px;
  box-sizing: border-box;
  background: #FFFFFF;
  border-radius: 24px 24px 0px 0px;
  .entrance-bottom {
    width: 100%;
    padding-bottom: 68px;
  }
  .title {
    font-weight: 500;
    font-size: 32px;
    color: #000000;
    line-height: 44px;
    margin-top: 8px;
  }
  .sub-title {
    font-weight: 400;
    font-size: 24px;
    color: #89898A;
    line-height: 32px;
    margin-top: 10px;
  }
  .title-icon {
    width: 316px;
    height: 348px;
    margin: 0 auto;
    margin-top: 32px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .btns-wrapper {
    text-align: center;
    .btn1 {
      width: 404px;
      height: 88px;
      line-height: 88px;
      background: linear-gradient( 153deg, #FF7673 0%, #FF3D3D 100%);
      border-radius: 48px;
      color: #FFFFFF;
      margin: 40px auto 0;
    }
    .btn2 {
      font-weight: 500;
      font-size: 24px;
      color: #666666;
      line-height: 32px;
      margin-top: 40px;
    }
  }
  .enter-type-wrapper {
    display: flex;
    justify-content: space-around;
    padding: 48px 0 0 0;
    text-align: center;
    .enter-type-item {
      width: 332px;
      font-weight: 500;
      font-size: 28px;
      color: #000000;
      line-height: 40px;
      background: #F8F8F8;
      border-radius: 20px;
      border: 2px solid #E5E5E5;
      img {
        width: 100%;
        height: 264px;
      }
      >div {
        margin: 28px 0;
      }
      &:nth-child(2) {
        margin-left: 22px;
      }
    }
  }
  .order-time-tips {
    margin: 46px auto 0;
    width: fit-content;
    height: 56px;
    padding: 0 40px;
    line-height: 56px;
    background: #F9F8F8;
    border-radius: 20px;
    font-weight: 400;
    font-size: 20px;
    color: #666666;
  }
}
</style>